import { UserNearVitals } from "../../redux/devicesStatuses";
import {
  AlertSocket,
  GetAlertDTO,
  GetAlertUpdateDTO,
  Reminder,
  ReminderAction,
  StatusSettings,
} from ".";
import { defaultOptions, residentsReqOptions } from "../residents";
import {
  AlertActionType,
  ALERTS,
  IGetNewReminderBySocket,
  IGetReminderMissedBySocket,
  IGetReminderHandledBySocket,
  IGetUserNearbyBySocket,
} from "./types";

export function getAlertByIdRequest(value: GetAlertDTO): AlertActionType {
  return { type: ALERTS.GET_ALERTS_BY_RESIDENT_ID_REQUEST, payload: value };
}
export function getAlertByIdSuccess(
  value: GetAlertUpdateDTO[]
): AlertActionType {
  return { type: ALERTS.GET_ALERTS_BY_RESIDENT_ID_SUCSSESS, payload: value };
}
export function getAlertByIdFailure(value: any): AlertActionType {
  return { type: ALERTS.GET_ALERTS_BY_RESIDENT_ID_FAILURE, payload: value };
}

export function getAlertsFromResidentRequest(
  value: residentsReqOptions
): AlertActionType {
  return {
    type: ALERTS.GET_ALERTS_FROM_RESIDENT_REQUEST,
    payload: value !== undefined ? value : defaultOptions,
  };
}
export function getAlertsFromResidentSuccess(value: any): AlertActionType {
  return { type: ALERTS.GET_ALERTS_FROM_RESIDENT_SUCCESS, payload: value };
}
export function getAlertsFromResidentFailure(value: any): AlertActionType {
  return { type: ALERTS.GET_ALERTS_FROM_RESIDENT_FAILURE, payload: value };
}

export function setMonitorAlertsSettings(
  value: StatusSettings
): AlertActionType {
  return { type: ALERTS.SET_MONITOR_ALERTS_SETTINGS, payload: value };
}

export function getNewAlertBySocket(value: AlertSocket): AlertActionType {
  return { type: ALERTS.GET_NEW_ALERT_BY_SOCKET, payload: value };
}

export function getNewReminderBySocket(
  value: Reminder
): IGetNewReminderBySocket {
  return { type: ALERTS.GET_NEW_REMINDER_BY_SOCKET, payload: value };
}

export function getReminderMissedBySocket(
  value: ReminderAction
): IGetReminderMissedBySocket {
  return { type: ALERTS.GET_REMINDER_MISSED_BY_SOCKET, payload: value };
}

export function getReminderHandledBySocket(
  value: ReminderAction
): IGetReminderHandledBySocket {
  return { type: ALERTS.GET_REMINDER_HANDLED_BY_SOCKET, payload: value };
}

export function getUserNearbyAlertsBySocket(
  deviceId: string,
  data: UserNearVitals[],
  room: string,
  bed: string
): IGetUserNearbyBySocket {
  return {
    type: ALERTS.GET_USER_NEARBY_BY_SOCKET,
    payload: { deviceId, data, room, bed },
  };
}
